import { createVNode as _createVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d7b7768")

_pushScopeId("data-v-7d7b7768")
const _hoisted_1 = { class: "clearfix" }
const _hoisted_2 = { class: "btnList" }
const _hoisted_3 = {
  ref: "firstButtonRef",
  class: "left"
}
const _hoisted_4 = { ref: "buttonList" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tooltip = _resolveComponent("el-tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      _createVNode("div", _hoisted_3, null, 512),
      _createVNode(_component_el_tooltip, {
        trigger: "hover",
        effect: "light"
      }, {
        content: _withId(() => [
          _createVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default")
          ], 512)
        ]),
        default: _withId(() => [
          _withDirectives(_createVNode(_component_el_button, {
            type: "primary",
            size: "mini",
            icon: "el-icon-more",
            class: "caret-button left"
          }, null, 512), [
            [_vShow, _ctx.isMore]
          ])
        ]),
        _: 1
      })
    ])
  ]))
})